import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import PartialIcon from "@/src/assets/icons/common/toggleable/IconIncomplete";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import Grid from "@mui/material/Grid";
import React from "react";
import { requiredValidator } from "@/src/services/validationRules";
import Group from "@/src/components/Wizard/Group";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type FinalClaimStatusClientProps = {
  product: AbstractCase;
  hasClaimStatusClient: boolean;
};
const FinalClaimStatusClient = ({ product, hasClaimStatusClient }: FinalClaimStatusClientProps) => {
  if (!hasClaimStatusClient) {
    return null;
  }

  return (
    <Grid size={12}>
      <Group
        type={"radio"}
        name={"finalClaimStatusClient"}
        question={"Wie ist der aktuelle Stand der Forderung aus Ihrer Sicht?"}
        options={[
          {
            labelText:
              product.caseCategory === "enforceClaim"
                ? "Die Forderung wird/wurde durch die Gegenseite voll erfüllt und der Fall kann abgeschlossen werden"
                : "Die Gegenseite hat die Forderung gegen mich vollständig aufgegeben und der Fall kann abgeschlossen werden. ",
            labelIcon: <CheckIcon />,
            labelIconActive: <CheckIcon active />,
            value: "fullyAgreed",
          },
          {
            labelText:
              product.caseCategory === "enforceClaim"
                ? "Die Forderung wird/wurde durch die Gegenseite nur teilweise erfüllt"
                : "Die Gegenseite hat die Forderung gegen mich teilweise aufgegeben ",
            labelIcon: <PartialIcon />,
            labelIconActive: <PartialIcon active />,
            value: "partiallyAgreed",
          },
          {
            labelText:
              product.caseCategory === "enforceClaim" ? "Die Forderung wird/wurde nicht erfüllt" : "Die Gegenseite hält vollständig an der Forderung fest",
            labelIcon: <CrossIcon />,
            labelIconActive: <CrossIcon active />,
            value: "notAgreed",
          },
        ]}
        validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
      />
    </Grid>
  );
};
export default FinalClaimStatusClient;
